import { useEffect } from 'react';
import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';
import { eventNameConstants, interactionTypeConstants, trackEvent } from 'dibs-tracking';
import { useClientState } from 'dibs-react-hooks/exports/useClientState.ts';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';
import headerReducer from '../reducers/headerReducer.ts';
import { actionCreators } from '../actions/index.ts';

const TEST_NAME = 'image_search';

const useImageSearchSelector: TypedUseSelectorHook<{ header: ReturnType<typeof headerReducer> }> =
    useSelector;
export const useImageSearch = (): {
    isImageSearchVariant: boolean;
    isImageSearchModalOpen: boolean;
    openImageSearchModal: () => void;
    closeImageSearchModal: () => void;
} => {
    const isClient = useClientState();
    const dispatch = useDispatch();
    const isImageSearchModalOpen = useImageSearchSelector(
        state => !!state.header.isImageSearchModalOpen
    );
    const isImageSearchAbTestTracked = useImageSearchSelector(
        state => !!state.header.isImageSearchAbTestTracked
    );
    const isImageSearchVariant = isClient && getAbTestV2(TEST_NAME)?.variant === 'variant';

    useEffect(() => {
        if (isClient && !isImageSearchAbTestTracked) {
            trackAbTestV2Variant(TEST_NAME);
            dispatch(actionCreators.setImageSearchAbTestTracked());
        }
    }, [isClient, dispatch, isImageSearchAbTestTracked]);

    return {
        isImageSearchVariant,
        isImageSearchModalOpen,
        openImageSearchModal: () => {
            dispatch(actionCreators.setImageSearchModalOpen());
            trackEvent({
                eventName: eventNameConstants.EVENT_NAVIGATION,
                interaction_type: interactionTypeConstants.INTERACTION_TYPE_GLOBAL_NAV,
                step_interaction_name: 'image search - click icon',
            });
        },
        closeImageSearchModal: () => {
            dispatch(actionCreators.setImageSearchModalClosed());
        },
    };
};
